import React from 'react';
import { ResponsiveContainer, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const LineChartWidget = ({ config = {} }) => {
  const title = config.title || 'Traffic Over Time';
  const showGrid = config.showGrid !== false;
  const showLegend = config.showLegend !== false;
  const smoothLine = config.smoothLine !== false;
  const isArea = config.areaChart === true;

  const demoData = config.data || [
    { name: 'Jan', organic: 4000, paid: 2400 },
    { name: 'Feb', organic: 3000, paid: 1398 },
    { name: 'Mar', organic: 5000, paid: 3800 },
    { name: 'Apr', organic: 4780, paid: 3908 },
    { name: 'May', organic: 5890, paid: 4800 },
    { name: 'Jun', organic: 6390, paid: 3800 },
    { name: 'Jul', organic: 7490, paid: 4300 }
  ];

  const metrics = config.metrics || Object.keys(demoData[0]).filter(k => k !== 'name');
  const colors = config.colors || ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'];

  const metricLabels = {
    organic: 'Organic', paid: 'Paid', social: 'Social',
    direct: 'Direct', referral: 'Referral', email: 'Email'
  };

  const ChartComponent = isArea ? AreaChart : LineChart;
  const DataComponent = isArea ? Area : Line;

  return (
    <div className="h-full flex flex-col bg-white p-3">
      <h3 className="text-sm font-semibold text-gray-700 mb-2" style={{ color: config.titleColor || '#374151' }}>
        {title}
      </h3>
      <div className="flex-1 min-h-0">
        <ResponsiveContainer width="100%" height="100%">
          <ChartComponent data={demoData}>
            {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />}
            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            {showLegend && <Legend wrapperStyle={{ fontSize: 11 }} />}
            {metrics.map((metric, idx) =>
              isArea ? (
                <Area
                  key={metric}
                  type={smoothLine ? 'monotone' : 'linear'}
                  dataKey={metric}
                  name={metricLabels[metric] || metric}
                  stroke={colors[idx % colors.length]}
                  fill={colors[idx % colors.length]}
                  fillOpacity={0.1}
                  strokeWidth={2}
                  dot={false}
                  activeDot={{ r: 4 }}
                />
              ) : (
                <Line
                  key={metric}
                  type={smoothLine ? 'monotone' : 'linear'}
                  dataKey={metric}
                  name={metricLabels[metric] || metric}
                  stroke={colors[idx % colors.length]}
                  strokeWidth={2}
                  dot={false}
                  activeDot={{ r: 4 }}
                />
              )
            )}
          </ChartComponent>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default LineChartWidget;
